import { Link, Paragraph } from '@vimeo/iris/typography';

export default function Me() {
  return (
    <div>
      <Paragraph size="2">
        The <code>/me</code> endpoint provides a convenient way to indicate the currently
        authenticated user. See the{' '}
        <Link variant="minimal" href="https://developer.vimeo.com/api/reference#about-endpoints">
          About endpoints
        </Link>{' '}
        section of the API Reference for more information.
      </Paragraph>

      <Paragraph size="2">Use the API to complete the following tasks:</Paragraph>
    </div>
  );
}
